import { datadogRum } from '@datadog/browser-rum';
import { Component, type ReactNode } from 'react';

type ErrorBoundaryProps = {
  children: ReactNode;
  fallback: (props: { error: Error }) => ReactNode;
};

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  { error: Error | null }
> {
  state = {
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    // Send error to RUM
    datadogRum.addError(error, {
      reactErrorInfo: info,
    });
  }

  render() {
    if (this.state.error) {
      return this.props.fallback({ error: this.state.error });
    }

    return this.props.children;
  }
}
